const VaultMessages = {
  HasBwInstalled: "hasBwInstalled",
  checkBwInstalled: "checkIfBWExtensionInstalled",
  OpenPopup: "openPopup",
  PopupOpened: "popupOpened",
} as const;

export { VaultMessages };
